import { DateTime } from "luxon";
import { GroupedVisits } from "./hook";

type NowLineProps = {
  show: boolean;
};

export const NowLine = ({ show }: NowLineProps) => {
  if (!show) return null;

  return (
    <div className="-ml-2">
      <div className="flex items-center">
        <div className="h-2 w-2 rounded-full bg-primary-600 -ml-[5px]" />
        <div className="h-0.5 bg-primary-600 w-full" />
      </div>
    </div>
  );
};

export function getCurrentOrNextVisitId(
  groupedVisits: GroupedVisits,
): string | undefined {
  const now = DateTime.local();

  // Flatten all visits from all dates into a single array
  const allVisits = Object.values(groupedVisits).flat();

  const completedVisits = allVisits.filter((v) => v.to <= now || v.clockOut);
  const upcomingVisits = allVisits.filter((v) => v.from > now);

  if (completedVisits.length > 0 && upcomingVisits.length > 0) {
    return upcomingVisits.sort(
      (a, b) => a.from.toMillis() - b.from.toMillis(),
    )[0].id;
  }

  const ongoingVisits = allVisits.filter((v) => v.from <= now && now < v.to);
  if (ongoingVisits.length > 0) {
    const target = ongoingVisits
      .filter((v) => v.from <= now)
      .sort((a, b) => b.from.toMillis() - a.from.toMillis())[0];
    return target.id;
  }

  const nextVisit = allVisits
    .filter((v) => v.from > now)
    .sort((a, b) => a.from.toMillis() - b.from.toMillis())[0];

  return nextVisit?.id;
}
